module.exports = __webpack_public_path__ + "static/media/fire_extinguisher.722b1752.svg";